import { LIMITLESS_LOCALE_KEY } from "@limitless/common/hooks/platform-resource/PlatformResourceHook";
import { ClientContext } from "@limitless/common/utils";
export const getUsersPreviousLocale = () => {
  const previousLocale = localStorage.getItem(LIMITLESS_LOCALE_KEY);
  if (previousLocale) {
    //override the app's locale with the users
    ClientContext._locale = previousLocale;
    return previousLocale;
  }
  return null;
};
export const doesUserHavePolicy = (policy, profile) => {
  if (!policy) {
    return false;
  }
  const {
    cognitoPolicies
  } = profile;
  if (!cognitoPolicies) {
    return false;
  }
  if (Array.isArray(policy)) {
    const hasAll = policy.every(pol => {
      return cognitoPolicies.includes(pol);
    });
    return hasAll;
  }
  if (cognitoPolicies.includes(policy)) {
    return true;
  }
  return false;
};